export default __webpack_public_path__ + "static/media/grafema_the-essence-collective_18.ce30b224.jpg";